import { post } from "@/utils/utils";

const assistantManagement = {
  state: {},
  mutations: {
    QUERY_GUIDER_TASL_LIST(state, data) {
      state.guiderTaskList = data.result;
    },
    ADD_GUIDER_TASK(state, data) {
      state.addGuiderTask = data.result;
    },
    FIND_GUIDER_LIST(state, data) {
      state.findGuiderList = data.result;
    },
    DETAILS_GUIDER_LIST(state, data) {
      state.detailsGuiderTask = data.result;
    },
    EDIT_GUIDER_LIST(state, data) {
      state.editGuiderTask = data.result;
    },
    DEL_GUIDER_LIST(state, data) {
      state.delGuiderTask = data.result;
    },
    ADD_REWARD_PLAN() {},
    REWARD_PLAN_LIST() {},
    DETAIL_REWARD_PLAN() {},
    DETAIL_REWARD_PLAN_bINDING_INFO() {},
    EDIT_REWARD_PLAN() {},
    REWARD_LIST() {},
    QUERY_SPU_LIST_GOODS_SN() {},
    QUERY_PLAN_EXPORT_LIST() {},
    ADD_STORE_SALE_TARGET() {},
    EDIT_STORE_SALE_TARGET() {},
    GET_BY_TARGET_ID() {},
    QUERY_STORE_SALE_TARGET_LIST() {},
    REWARD_ALL_LIST() {},
    QUERY_TASK_SUMMARY_LIST() {},
    QUERY_TASK_SUMMARY_ALL_LIST() {},
    QUERY_TARGET_MANGATE_LIST() {},
    QUERY_TARGET_TYPE_LIST() {},
    QUERY_TARGET_RANGE_LIST() {},
    SAVE_TARGET_RANGE_INFO() {},
    QUERY_DEFAULT_LIST() {},
    QUERY_TARGET_MONTHLY_LIST() {},
    QUERY_ALL_TARGET_MONTHLY_LIST() {},
    EDIT_TARGET_RANGE_INFO() {},
    EXPORT_GUIDER_REWAED() {},
    QUERY_GUIDER_SUMMARY() {},
    QUERY_PEOPLE_PACKAGE_CALC_RESULT() {},
    EXEC_PEOPLE_PACKAGE_CALC() {},
    QUERY_PEOPLE_PACKAGE_DETAIL_RESULT() {},
  },
  actions: {
    queryGuiderTaskList({ commit }, params) {
      return post({
        commit,
        url: `/guider/task/list`,
        name: "QUERY_GUIDER_TASL_LIST",
        params
      });
    },
    addGuiderTask({ commit }, params) {
      return post({
        commit,
        url: `/guider/task/add`,
        name: "ADD_GUIDER_TASK",
        params
      });
    },
    findGuiderList({ commit }, params) {
      return post({
        commit,
        url: `/guider/task/guider_list`,
        name: "FIND_GUIDER_LIST",
        params
      });
    },
    detailsGuiderTask({ commit }, params) {
      return post({
        commit,
        url: `/guider/task/detail`,
        name: "DETAILS_GUIDER_LIST",
        params
      });
    },
    editGuiderTask({ commit }, params) {
      return post({
        commit,
        url: `/guider/task/edit`,
        name: "EDIT_GUIDER_LIST",
        params
      });
    },
    delGuiderTask({ commit }, params) {
      return post({
        commit,
        url: `/guider/task/del`,
        name: "DEL_GUIDER_LIST",
        params
      });
    },
    addRewardPlan({ commit }, params) {
      return post({
        commit,
        url: `/sale/plan/add`,
        name: "ADD_REWARD_PLAN",
        params
      });
    },
    rewardPlanList({ commit }, params) {
      return post({
        commit,
        url: `/sale/plan/list`,
        name: "REWARD_PLAN_LIST",
        params
      });
    },
    detailRewardPlan({ commit }, params) {
      return post({
        commit,
        url: `/sale/plan/detail`,
        name: "DETAIL_REWARD_PLAN",
        params
      });
    },
    detailRewardPlanBindingInfo({ commit }, params) {
      return post({
        commit,
        url: `/sale/plan/binding_info`,
        name: "DETAIL_REWARD_PLAN_bINDING_INFO",
        params
      });
    },
    editRewardPlan({ commit }, params) {
      return post({
        commit,
        url: `/sale/plan/edit`,
        name: "EDIT_REWARD_PLAN",
        params
      });
    },
    rewardList({ commit }, params) {
      return post({
        commit,
        url: `/sale/plan/reward/list`,
        name: "REWARD_LIST",
        params
      });
    },
    rewardAllList({ commit }, params) {
      return post({
        commit,
        url: `/sale/plan/reward/list`,
        name: "REWARD_ALL_LIST",
        params
      });
    },
    querySpuListGoodsSn({ commit }, params) {
      return post({
        commit,
        url: `/basic/spu/spu_list/goods_sn`,
        name: "QUERY_SPU_LIST_GOODS_SN",
        params
      });
    },
    queryPlanExportList({ commit }, params) {
      return post({
        commit,
        url: `/sale/plan/export/list`,
        name: "QUERY_PLAN_EXPORT_LIST",
        params
      });
    },
    saveStoreSaleTargetInfo({ commit }, params) {
      return post({
        commit,
        url: `/store/storeSaleTargetInfo/add`,
        name: "ADD_STORE_SALE_TARGET",
        params
      });
    },
    editStoreSaleTargetInfo({ commit }, params) {
      return post({
        commit,
        url: `/store/storeSaleTargetInfo/edit`,
        name: "EDIT_STORE_SALE_TARGET",
        params
      });
    },
    getByTargetId({ commit }, params) {
      return post({
        commit,
        url: `/store/storeSaleTargetInfo/getByTargetId`,
        name: "GET_BY_TARGET_ID",
        params
      });
    },
    queryStoreSaleTargetList({ commit }, params) {
      return post({
        commit,
        url: `/store/storeSaleTargetInfo/list`,
        name: "QUERY_STORE_SALE_TARGET_LIST",
        params
      });
    },
    queryTaskSummaryList({ commit }, params) {
      return post({
        commit,
        url: `/guider/task/summary_list`,
        name: "QUERY_TASK_SUMMARY_LIST",
        params
      });
    },
    queryTaskSummaryAllList({ commit }, params) {
      return post({
        commit,
        url: `/guider/task/summary_list`,
        name: "QUERY_TASK_SUMMARY_ALL_LIST",
        params
      });
    },
    queryTargetManageList({ commit }, params) {
      return post({
        commit,
        url: `/reports/storeTargetManageInfo/queryCustomList`,
        name: "QUERY_TARGET_MANGATE_LIST",
        params
      });
    },
    queryTargetTypeList({ commit }, params) {
      return post({
        commit,
        url: `/sys/common/dict_items?dictCode=target_type`,
        name: "QUERY_TARGET_TYPE_LIST",
        params
      });
    },
    queryTargetRangeList({ commit }, params) {
      return post({
        commit,
        url: `/sys/common/dict_items?dictCode=target_range`,
        name: "QUERY_TARGET_RANGE_LIST",
        params
      });
    },
    saveTargetRangeInfo({ commit }, params) {
      return post({
        commit,
        url: `/reports/storeTargetManageInfo/config`,
        name: "SAVE_TARGET_RANGE_INFO",
        params
      });
    },
    queryDefaultList({ commit }, params) {
      return post({
        commit,
        url: `/reports/storeTargetManageInfo/queryDefaultList`,
        name: "QUERY_DEFAULT_LIST",
        params
      });
    },
    queryTargetMonthlyList({ commit }, params) {
      return post({
        commit,
        url: `/reports/storeTargetMonthlySummary/queryPageList`,
        name: "QUERY_TARGET_MONTHLY_LIST",
        params
      });
    },
    queryAllTargetMonthlyList({ commit }, params) {
      return post({
        commit,
        url: `/reports/storeTargetMonthlySummary/queryPageList`,
        name: "QUERY_ALL_TARGET_MONTHLY_LIST",
        params
      });
    },
    editTargetRangeInfo({ commit }, params) {
      return post({
        commit,
        url: `/reports/storeTargetMonthlySummary/edit`,
        name: "EDIT_TARGET_RANGE_INFO",
        params
      });
    },
    exportGuiderReward({ commit }, params) {
      return post({
        commit,
        url: `/sale/plan/exportGuiderReward?false`,
        name: "EXPORT_GUIDER_REWAED",
        params
      });
    },
    queryGuiderSummary({ commit }, params) {
      return post({
        commit,
        url: `/guider/task/summary`,
        name: "QUERY_GUIDER_SUMMARY",
        params
      });
    },
    queryPeoplePackageCalcResult({ commit }, params) {
      return post({
        commit,
        url: `/store/ssrBasicConfig/queryPeoplePackageCalcResult`,
        name: "QUERY_PEOPLE_PACKAGE_CALC_RESULT",
        params
      });
    },
    execPeoplePackageCalc({ commit }, params) {
      return post({
        commit,
        url: `/store/ssrBasicConfig/execPeoplePackageCalc`,
        name: "EXEC_PEOPLE_PACKAGE_CALC",
        params
      });
    },
    queryPeoplePackageDetailResult({ commit }, params) {
      return post({
        commit,
        url: `/store/ssrBasicConfig/queryPeoplePackageDetailResult`,
        name: "QUERY_PEOPLE_PACKAGE_DETAIL_RESULT",
        params
      });
    },
  }
};

export default assistantManagement;
